export function productGallery() {
    let $productGalleryContainer = $(".product-gallery");
    let $productGalleryPicture = $productGalleryContainer.find(".product-gallery-img");
    let $productGalleryThumb = $productGalleryContainer.find(".product-gallery-thumb");

    $productGalleryPicture.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: ".product-gallery-thumb"
    });

    $productGalleryThumb.slick({
        slidesToScroll: 1,
        slidesToShow: 3.26,
        asNavFor: ".product-gallery-img",
        // variableWidth: true,
        dots: false,
        arrows: false,
        // focusOnSelect: true,
        infinite: false,
        focusOnSelect: true
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/productGallery.js